var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCarteora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.850098 5.72656C0.850098 3.51742 2.64096 1.72656 4.8501 1.72656H12.8501C15.0592 1.72656 16.8501 3.51742 16.8501 5.72656V11.7266C16.8501 13.9357 15.0592 15.7266 12.8501 15.7266H4.8501C2.64096 15.7266 0.850098 13.9357 0.850098 11.7266V5.72656Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.72646C0 3.04788 2.17142 0.876465 4.85 0.876465H12.85C15.5286 0.876465 17.7 3.04788 17.7 5.72646V11.7265C17.7 14.405 15.5286 16.5765 12.85 16.5765H4.85C2.17142 16.5765 0 14.405 0 11.7265V5.72646ZM4.85 2.57646C3.1103 2.57646 1.7 3.98677 1.7 5.72646V11.7265C1.7 13.4662 3.1103 14.8765 4.85 14.8765H12.85C14.5897 14.8765 16 13.4662 16 11.7265V5.72646C16 3.98677 14.5897 2.57646 12.85 2.57646H4.85Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 8.72656C14.8501 9.27885 14.4024 9.72656 13.8501 9.72656C13.2978 9.72656 12.8501 9.27885 12.8501 8.72656C12.8501 8.17428 13.2978 7.72656 13.8501 7.72656C14.4024 7.72656 14.8501 8.17428 14.8501 8.72656Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.72646C10 6.15245 11.276 4.87646 12.85 4.87646H16.85C17.3194 4.87646 17.7 5.25702 17.7 5.72646V11.7265C17.7 12.1959 17.3194 12.5765 16.85 12.5765H12.85C11.276 12.5765 10 11.3005 10 9.72646V7.72646ZM12.85 6.57646C12.2149 6.57646 11.7 7.09134 11.7 7.72646V9.72646C11.7 10.3616 12.2149 10.8765 12.85 10.8765H16V6.57646H12.85Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarteora);
export default __webpack_public_path__ + "static/media/icon_carteora.8cbe1b1ca43788d3f050a2a37da97423.svg";
export { ForwardRef as ReactComponent };